import * as React from 'react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useData, useHandlers } from './hooks'
import type { ActivityType } from '../../../typings'
import useTheme from '@mui/material/styles/useTheme'

type Props = {
  activityTypes: ActivityType[]
}

export function ActivityTypesListHeader(props: Props) {
  const { isAddDisabled, maxActionTypes, currentQuantity } = useData(props)
  const { handleAddClick } = useHandlers()
  const theme = useTheme()

  return (
    <Stack direction="row" mb={2.6} alignItems="center">
      <Stack mr="auto">
        <Typography
          variant="body1"
          fontSize={16}
          color={theme.palette.text.primary}
        >
          Manage your Activity Types
        </Typography>
        <Typography variant="caption" color={theme.palette.text.primary}>
          {maxActionTypes - currentQuantity} out of {maxActionTypes} Activity
          Types Available
        </Typography>
      </Stack>
      <Button
        variant="contained"
        onClick={handleAddClick}
        disabled={isAddDisabled}
      >
        Create Activity Type
      </Button>
    </Stack>
  )
}
